export default "__VITE_ASSET__y22xbWqy__"